import './gazetteer-mobile-modal.css';

import mapIcon from '@disy/cadenza-icons/map.svg';
import $ from 'jquery';
import h from 'hyperscript';

import { Modal } from 'ui/dialog/modal/modal';

import i18n from './messages.properties';

const NAME = 'd-gazetteer-mobile-modal';

export class GazetteerMobileModal extends Modal {

  #components;
  #clearSearch;

  constructor (components, clearSearch) {
    super(mapIcon, 'Gazetteer');
    this.#components = components;
    this.#clearSearch = clearSearch;
  }

  connectedCallback () {
    super.connectedCallback();
    this.classList.add(NAME);
    this.body.append(h('.d-gazetteer-mobile-modal--input', ...this.#components));
    this.footer.append(
      h(
        'button.button.button-primary', {
          type: 'button',
          onclick: () => this.cancel()
        },
        i18n('gazetteerMobileButton.title')
      ),
      h(
        'button.button.cancel', {
          type: 'button',
          onclick: () => {
            this.#clearSearch();
            this.cancel();
          }
        },
        i18n('common:cancel')
      )
    );
    const input = this.body.querySelector('.d-gazetteer-search-field');
    $(input).gazetteerAutocomplete('option', 'appendTo', '.d-gazetteer-mobile-modal .d-modal--body');
  }

}

customElements.define(NAME, GazetteerMobileModal);
